import { render, staticRenderFns } from "./OtpForm.vue?vue&type=template&id=1be8d8c2&"
import script from "./OtpForm.vue?vue&type=script&lang=js&"
export * from "./OtpForm.vue?vue&type=script&lang=js&"
import style0 from "./OtpForm.vue?vue&type=style&index=0&id=1be8d8c2&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports